/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateVendorCommand } from '../../models/update-vendor-command';
import { UpdateVendorCommandResult } from '../../models/update-vendor-command-result';

export interface ApiVendorsUpdateVendorPut$Params {
  
    /**
     * The command containing the updated details for the Vendor.
     */
    body?: UpdateVendorCommand
}

export function apiVendorsUpdateVendorPut(http: HttpClient, rootUrl: string, params?: ApiVendorsUpdateVendorPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateVendorCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiVendorsUpdateVendorPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateVendorCommandResult>;
    })
  );
}

apiVendorsUpdateVendorPut.PATH = '/api/Vendors/UpdateVendor';
